import { gql } from "@apollo/client";

export const lookupHealthProfessionQuery = gql`
  query healthProfession {
    healthProfessionsData @rest (type: "healthProfessions" path: "/public/health-professions.json") {
      healthProfessions {
        professionCode
        professionName
      }
    }
  }
`;